import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import messages from './locales'

// 导入 Tailwind CSS
import './assets/tailwind.css'

// 导入 Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(VueI18n)


const i18n = new VueI18n({
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')